import { useQuery } from '@apollo/client';

import { ProviderPlanId, Role } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { CreditCardStatus } from 'types/creditCard';
import { Package } from 'types/package';

import { PhysicalCardOrderFlowDocument } from './physicalCardOrderFlow.gql';

export interface PhysicalCardOrderFlowQueryData {
  viewer: {
    uid: string;
    profile: {
      firstName: string;
      lastName: string;
      street: string;
      streetAddition: string;
      city: string;
      zip: string;
    };
    company: {
      bankAccount: {
        bankAccountId: string;
        nextBalance: number;
      };
      companyProfileId: string;
      creditCards: {
        creditCardId: string;
        isPremium: boolean;
        isPhysical: boolean;
        isDefinitivelyBlocked: boolean;
        status: CreditCardStatus;
      }[];
      currentPlan: {
        providerPlanId: ProviderPlanId;
        features: string[];
        paymentCard: {
          type: string;
        };
      };
      profile: {
        companyProfileId: string;
        legalForm: string;
        street: string;
        city: string;
        zip: string;
      };
    };
    companyUser: {
      roles: Role[];
    };
  };
  newBasicCardPrice: Package;
  newPremiumCardPrice: Package;
  basicCardMonthlyFee: Package;
  premiumCardMonthlyFee: Package;
}

export function usePhysicalCardOrderFlowQuery() {
  const { companyProfileId, companyUserId } = useCompanyContext();

  return useQuery<PhysicalCardOrderFlowQueryData>(
    PhysicalCardOrderFlowDocument,
    {
      skip: !companyProfileId || !companyUserId,
      variables: {
        companyProfileId: companyProfileId as string,
        companyUserId: companyUserId as string,
      },
    },
  );
}
